import './tablet-button.scss';
import {Box} from '@mui/material';
import {translations} from '../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {AppButtonColors} from '../../utils/constants/colors';
import {useState, useEffect} from 'react';
import {isSvg} from '../../utils/functions/validate-uri-svg';

// use Audio constructor to create HTMLAudioElement
const buttonClickAudio = new Audio('/audio/app-button-click.mp3');

/**
 * Tablet button component used in the entity services screen.
 */
export const TabletButton = (props: {
  imageUrl: string;
  iconUrl: string;
  title?: string;
  appButtonColors: AppButtonColors;
  emptyTitle?: string;
}) => {
  // Translations
  const {t} = useTranslation();

  // Hold State
  const [pressed, setPressed] = useState(false);

  // Events
  const handleTouchEvent = (event: any) => {
    var e = event || window.event;
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    e.cancelBubble = true;
    e.returnValue = false;
    return false;
  };
  const handleTouchStart = (event: any) => {
    // Stop Touch
    handleTouchEvent(event);

    // Play Sound
    buttonClickAudio.play();

    // Animate
    setPressed(true);
  };
  const handleTouchEnd = (event: any) => {
    // Stop Touch
    handleTouchEvent(event);

    // Animate
    setPressed(false);
  };

  // On mount
  useEffect(() => {
    // Load buttonClickAudio
    buttonClickAudio.load();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      className={`tablet-button ${pressed ? 'pressed' : ''}`}
      onTouchStart={handleTouchStart}
      onMouseDown={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseUp={handleTouchEnd}
      onTouchMove={handleTouchEvent}
      onTouchCancel={handleTouchEvent}
      onBlur={handleTouchEnd}
    >
      <Box className="image-button">
        <Box className="white-container">
          <Box className="image">
            {props.imageUrl && props.imageUrl !== '' ? (
              <img src={props.imageUrl} alt="" />
            ) : undefined}
          </Box>
          <Box className="shadow"></Box>
        </Box>
      </Box>
      <Box className="circular-button">
        <Box className="circle-container">
          <Box className="grey-inner-circle-container">
            <Box
              className="app-color-inner-circle-container"
              sx={{
                background: pressed ? props.appButtonColors.pressed : props.appButtonColors.enabled,
                boxShadow: `0px -0.5px 12px 0px ${props.appButtonColors.pressed} inset, 2px 0px 4px 0px rgba(0, 0, 0, 0.25)`,
              }}
            >
              <Box className="icon-xl-container">
                {props.iconUrl && props.iconUrl !== '' ? (
                  isSvg(props.iconUrl) ? (
                    <object data={props.iconUrl} aria-label="icon" type="image/svg+xml"></object>
                  ) : (
                    <img src={props.iconUrl} alt="" />
                  )
                ) : undefined}
              </Box>
              <Box className="text-label-container">
                <Box className="text">
                  {props.title && props.title.trim() !== ''
                    ? props.title
                    : props.emptyTitle
                      ? `(${props.emptyTitle})`
                      : t(translations.tablet_button.empty_title)}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="touch-selection-protector"></Box>
    </Box>
  );
};
